/**
 * Created by patricio on 08/09/14.
 */

define('all/slidingContentWrapper',['jquery','boxes/controllers/signup-controller', 'boxes/controllers/login-controller', 'boxes/controllers/deposit-controller', 'boxes/controllers/withdraw-controller', 'all/slidingContentNavigation'], function($, signUpController, loginController, depositController, withdrawController, slidingContentNavigation) {
    'use strict';

    function showSlidingForgottenPassword() {
        slidingContentNavigation.setHash(loginController.startForgottenPasswordClass.createHashTag());
    }

	function showSlidingChangePassword() {
		slidingContentNavigation.setHash(loginController.startChangePasswordClass.createHashTag());
	}

    function showSlidingLoginPopup() {
        slidingContentNavigation.setHash(loginController.startLoginClass.createHashTag());
    }

    function showSlidingReloginPopup() {
        slidingContentNavigation.setHash(loginController.startReLoginClass.createHashTag());
    }

    function showSlidingDeposit(bonusId) {
        var isInGameDeposit = false;
        if (top.location.href.indexOf('game') !== -1 || top.location.href.indexOf('group') !== -1) {
            isInGameDeposit = true;
        }

		//we don't want to pass mouse event objects
		bonusId = typeof(bonusId) === "string" ? bonusId : "";

        slidingContentNavigation.setHash(depositController.startDepositClass.createHashTag({
            isInGameDeposit: isInGameDeposit,
			bonusId: bonusId
        }));
    }

    function showSlidingInstantDeposit(amount) {
        slidingContentNavigation.setHash(depositController.startInstantDepositClass.createHashTag({
            amount: amount
        }));
    }

    function showSlidingDepositBonus(bonusId, closePanelRedirectUrl, carousel) {
		if(carousel) {
			showSlidingDeposit(bonusId, closePanelRedirectUrl);
		} else {
			slidingContentNavigation.setHash(depositController.startDepositBonusClass.createHashTag({
				bonusId: bonusId,
				closePanelRedirectUrl: closePanelRedirectUrl
			}));
		}
    }

    function showSlidingWithdraw() {
        slidingContentNavigation.setHash(withdrawController.startWithdrawClass.createHashTag());
    }

    function showSlidingSignup() {
        slidingContentNavigation.setHash(signUpController.startSignupClass.createHashTag());
    }

    var allDefaultStartControllerClasses = [
		loginController.startChangePasswordClass,
        loginController.startForgottenPasswordClass,
        loginController.startLoginClass,
        loginController.startReLoginClass,
        depositController.startDepositClass,
        depositController.startInstantDepositClass,
        depositController.startDepositBonusClass,
        withdrawController.startWithdrawClass,
        signUpController.startSignupClass
    ];


    return {
		showSlidingChangePassword: showSlidingChangePassword,
        showSlidingForgottenPassword: showSlidingForgottenPassword,
        showSlidingLoginPopup: showSlidingLoginPopup,
        showSlidingReloginPopup: showSlidingReloginPopup,
        showSlidingDeposit: showSlidingDeposit,
        showSlidingInstantDeposit: showSlidingInstantDeposit,
        showSlidingDepositBonus: showSlidingDepositBonus,
        showSlidingWithdraw: showSlidingWithdraw,
        showSlidingSignup: showSlidingSignup,
        allDefaultStartControllerClasses : allDefaultStartControllerClasses
    };
});

